export default {"src":"/_next/static/media/shopify.dba064e0.svg","height":52,"width":52};